import React from "react";
// ApprovalCard is a sibling admin page in this conversion batch — import normally.
import ApprovalCard from "./ApprovalCard";

interface ComparisonCardProps {
  title?: string;
  // current / newChange / current*/new* are rendered straight into JSX as
  // children (inside ComparisonBox). Callers feed them codegen-nullable and
  // formatted values (string | null, getMetaValue results); widen to ReactNode
  // so those values pass through unchanged — the JSX rendered them the same way.
  current?: React.ReactNode;
  newChange?: React.ReactNode;
  changes: string[];
  currentLabel?: string;
  newChangeLabel?: string;
  nameChange?: boolean;
  changeType?: "name" | "address" | "yellowPath";
  currentFirst?: React.ReactNode;
  currentLast?: React.ReactNode;
  newFirst?: React.ReactNode;
  newLast?: React.ReactNode;
}

interface ComparisonBoxProps {
  children?: React.ReactNode;
  className?: string;
}

const ComparisonBox = ({ children, className }: ComparisonBoxProps) => (
  <div className={`address-box  ${className || ""}`}>
    <p> {children}</p>
  </div>
);

const ComparisonCard = ({
  title,
  current,
  newChange,
  changes,
  currentLabel,
  newChangeLabel,
  nameChange,
  changeType,
  currentFirst,
  currentLast,
  newFirst,
  newLast,
}: ComparisonCardProps) => (
  <ApprovalCard title={title}>
    {changeType === "yellowPath" ? (
      <div className="detected-changes mt-3">
        <p> Failure Reason:</p>
        <ul>
          {changes.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      </div>
    ) : (
      <>
        <div className="row">
          <div className="col-md-6">
            <p
              className="account-info-label"
              style={{ color: "#0a2540", paddingBottom: "15px" }}
            >
              {currentLabel}:
            </p>

            {changeType === "name" || nameChange ? (
              <>
                <p className="account-info-label">First Name:</p>
                <ComparisonBox className="current-name">
                  {currentFirst}
                </ComparisonBox>
                <p className="account-info-label">Last Name:</p>
                <ComparisonBox className="current-name">
                  {currentLast}
                </ComparisonBox>
              </>
            ) : (
              <ComparisonBox className="address-change-box">
                {current}
              </ComparisonBox>
            )}
          </div>
          <div className="col-md-6">
            <p
              className="account-info-label"
              style={{ color: "#0a2540", paddingBottom: "15px" }}
            >
              {newChangeLabel}:
            </p>

            {changeType === "name" || nameChange ? (
              <>
                <p className="account-info-label">First Name:</p>
                <ComparisonBox className="name-change-box">
                  {newFirst}
                </ComparisonBox>
                <p className="account-info-label">Last Name:</p>
                <ComparisonBox className="name-change-box">
                  {newLast}
                </ComparisonBox>
              </>
            ) : (
              <ComparisonBox className="address-change-box">
                {newChange}
              </ComparisonBox>
            )}
          </div>
        </div>
        <div className="detected-changes mt-3">
          <p>Detected Changes</p>
          <ul>
            {changes.map((msg, i) => (
              <li key={i}>{msg}</li>
            ))}
          </ul>
        </div>
      </>
    )}
  </ApprovalCard>
);

export default ComparisonCard;
